import { Component } from "react";
import ReactImageGallery from "react-image-gallery";
import { picturesShape } from "../../shapes/picturesShape";
import {
  addAccessTokenToLcmApiUrl,
  isSomething,
  isMobileDevice,
  url,
} from "../../utils";

import { withConfiguration, withSession } from "../../context";

type Props = {
  pictures?: picturesShape;
  placeholder?: string;
  configuration: {
    lcmApiUrl?: string;
  };
  session: {
    token?: string;
  };
  onPictureChange?: $TSFixMeFunction;
  children?: React.ReactNode;
};

type State = $TSFixMe;

export class PictureGallery extends Component<Props, State> {
  gallery: $TSFixMe;

  selectedPictureIndex: $TSFixMe;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.renderItem = this.renderItem.bind(this);
    this.onScreenChange = this.onScreenChange.bind(this);
    this.onImageClick = this.onImageClick.bind(this);
    this.onSlide = this.onSlide.bind(this);
    this.state = { fullscreen: false, pictureItems: null };
    this.selectedPictureIndex = 0;
  }

  componentDidMount() {
    this.updatePictureItems(this.props);
  }

  componentDidUpdate(prevProps: Props) {
    const { pictures, onPictureChange } = this.props;

    if (pictures !== prevProps.pictures) {
      this.updatePictureItems(this.props);
    }

    if (prevProps.pictures !== pictures && pictures && onPictureChange) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      onPictureChange(this.props.pictures[this.selectedPictureIndex]);
    }

    if (
      this.gallery &&
      pictures &&
      prevProps.pictures &&
      pictures.length > prevProps.pictures.length
    ) {
      this.gallery.slideToIndex(pictures.length - 1);
    }
  }

  onImageClick() {
    if (this.gallery.state.isFullscreen) {
      this.gallery.exitFullScreen();
      this.setState({ fullscreen: false });
    } else {
      this.gallery.fullScreen();
      this.setState({ fullscreen: true });
    }
  }

  onSlide(index: $TSFixMe) {
    const { onPictureChange, pictures } = this.props;
    if (onPictureChange) {
      this.selectedPictureIndex = index;
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      onPictureChange(pictures[index]);
    }
  }

  onScreenChange(fullscreenElement: $TSFixMe) {
    this.setState({ fullscreen: isSomething(fullscreenElement) });
  }

  updatePictureItems(props: $TSFixMe) {
    const { pictures, additionalPictureUrls } = props;

    const pictureItems: $TSFixMe = [];

    if (additionalPictureUrls) {
      additionalPictureUrls.forEach((picUrl: $TSFixMe) =>
        pictureItems.push({ original: picUrl }),
      );
    }

    if (pictures) {
      pictures.sort((a: $TSFixMe, b: $TSFixMe) => a.id - b.id);
      pictures.forEach((picture: $TSFixMe) =>
        pictureItems.push({ original: picture.url }),
      );
    }

    if (pictureItems.length > 0) {
      this.setState({ pictureItems });
    } else {
      this.setState({ pictureItems: null });
    }
  }

  renderItem(item: $TSFixMe) {
    const { session, configuration } = this.props;
    const pictureUrl = addAccessTokenToLcmApiUrl(
      item.original,
      configuration.lcmApiUrl,
      session.token,
    );
    const picture = this.state.fullscreen ? (
      <img src={pictureUrl} alt="" />
    ) : (
      <div
        data-testid="picture-gallery-image"
        className="picture"
        style={{
          backgroundImage: `url(${pictureUrl}), url(${url("/images/no-picture.png")}`,
        }}
      />
    );

    return <div className="pictures-picture sentry-mask">{picture}</div>;
  }

  render() {
    const { placeholder, children } = this.props;
    const { pictureItems } = this.state;
    const renderedPlaceholder = pictureItems ? null : (
      <div className="pictures-placeholder centralize">
        <span data-testid={placeholder} className={`icon ${placeholder}`} />
      </div>
    );

    const gallery = pictureItems ? (
      <ReactImageGallery
        ref={
          /* istanbul ignore next */ (e) => {
            /* istanbul ignore next */ this.gallery = e;
          }
        }
        items={pictureItems}
        slideInterval={2000}
        slideDuration={300}
        showThumbnails={false}
        showNav={pictureItems.length > 1 && !isMobileDevice()}
        renderItem={this.renderItem}
        showFullscreenButton={false}
        showIndex={pictureItems.length > 1}
        onScreenChange={this.onScreenChange}
        showPlayButton={false}
        onClick={this.onImageClick}
        onSlide={this.onSlide}
        infinite
        lazyLoad
      />
    ) : null;

    return (
      <div className="pictures sentry-block">
        {children}
        {renderedPlaceholder}
        {gallery}
      </div>
    );
  }
}

export default withConfiguration(withSession(PictureGallery));
